module.exports = "/assets/data/3bedef7587180f29dab965d4c14fd2f4-CH63.data.json";